import React, { useCallback } from 'react';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import { SUBSCRIBER_CARD_DATA, getEmployeeProfileURL } from 'global/checklists-helpers/SubscriberChecklistHelper';
import useSubscriberTaskUrlParams from 'global/hooks/useSubscriberTaskUrlParams';
import { bpHistory } from 'global/bpHistory';

const QuoteManageElectionsPage: React.FC = () => {
  const { groupId } = useSubscriberTaskUrlParams();
  const returnBack = useCallback((): void => {
    bpHistory.push(getEmployeeProfileURL({ groupId }));
  }, [groupId]);

  return (
    <NoSidebarPageLayout
      contentWidth="standard"
      isInitialLoading={false}
      isInfoSectionLoading={false}
      pageHeader={{
        title: SUBSCRIBER_CARD_DATA.QUOTING_ELECTIONS.title,
        subtitle: SUBSCRIBER_CARD_DATA.QUOTING_ELECTIONS.text,
        onBackButtonClick: returnBack,
      }}
    >
      {null}
    </NoSidebarPageLayout>
  );
};

export default QuoteManageElectionsPage;
